import { useCallback } from 'react';

import { toast } from 'react-toastify';

type ClipboardUtils = {
  /** Copie la chaine donnée dans le presse-papier. Peut afficher un toast en même temps. */
  copyToClipboard: (text: string, toastMessage?: string) => void;
};

/**
 * Hook utilitaire pour les actions en lien avec le presse-papier
 */
const useClipboard = (): ClipboardUtils => {
  const copyToClipboard = useCallback((text: string, toastMessage?: string) => {
    navigator.clipboard.writeText(text);

    if (toastMessage) {
      toast(toastMessage, { toastId: 'clipboard-copied', type: 'success', autoClose: 2000 });
    }
  }, []);

  return { copyToClipboard };
};

export default useClipboard;
